import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('notary')
export class Notary {
  @JsonProperty('name', String, true)
  public name = '';

  @JsonProperty('firstname', String, true)
  public firstname = '';

  @JsonProperty('address', String, true)
  public address = '';

  @JsonProperty('completaryAddress', String, true)
  public completaryAddress = '';

  @JsonProperty('zipcode', String, true)
  public zipcode = '';

  @JsonProperty('city', String, true)
  public city = '';

  @JsonProperty('country', String, true)
  public country = '';

  @JsonProperty('email', String, true)
  public email = '';

  @JsonProperty('phoneNumber', String, true)
  public phoneNumber = '';
}

@JsonObject('notaryInformations')
export class NotaryInformation {
  @JsonProperty('hasNotary', String, true)
  public hasNotary = '';

  @JsonProperty('notary', Notary, true)
  public notary: Notary = new Notary();

  @JsonProperty('readOnlyNotary', Boolean, true)
  public readOnlyNotary = false;
}
